import { render } from "./TimetableList.vue?vue&type=template&id=51c6ddc0&lang=pug"
import script from "./TimetableList.vue?vue&type=script&lang=js"
export * from "./TimetableList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__